import { render, staticRenderFns } from "./AdditionSingle.vue?vue&type=template&id=2effaec4&"
import script from "./AdditionSingle.vue?vue&type=script&lang=ts&"
export * from "./AdditionSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2effaec4')) {
      api.createRecord('2effaec4', component.options)
    } else {
      api.reload('2effaec4', component.options)
    }
    module.hot.accept("./AdditionSingle.vue?vue&type=template&id=2effaec4&", function () {
      api.rerender('2effaec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Additions/AdditionSingle.vue"
export default component.exports